//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Articles",
  emits:['close'],
   props: {
    content:{
      type:Array,
      required:true,
      default(){
        return [];
      }
    },
    activeCategory:{
      type:String,
      reuqired: false,
      default(){
        return '';
      }
    }
  },
  data(){
    return{
      isShow: true,
      articlesCounter:3,
    }
  },
  computed:{
    getArticlesCounter(){
      if(this.activeCategory === '5'){
          return this.content.length ;
        }
        return this.articlesCounter;
    }
  }
};
